function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#50DB98"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.24854 12.136H8.89463C8.90557 12.3985 9.0113 12.6191 9.21182 12.7978C9.41598 12.9764 9.69489 13.0657 10.0485 13.0657C10.384 13.0657 10.6556 12.9928 10.8634 12.847C11.0712 12.6975 11.1769 12.4988 11.1806 12.2509C11.1879 12.0576 11.1259 11.8899 10.9946 11.7478C10.8634 11.6056 10.6155 11.4816 10.2509 11.3759L9.32119 11.1188C7.99046 10.7069 7.3251 9.96676 7.3251 8.89854C7.3251 8.27874 7.54202 7.76103 7.97588 7.34541C8.40973 6.92979 8.96208 6.68734 9.63291 6.61807V5.42041H10.4532V6.629C11.0912 6.7165 11.6071 6.96624 12.0009 7.37822C12.3946 7.7902 12.5915 8.31702 12.5915 8.95869H10.9563C10.9563 8.69619 10.8688 8.48473 10.6938 8.32432C10.5225 8.1639 10.2782 8.08369 9.96104 8.08369C9.67301 8.08369 9.43421 8.15661 9.24463 8.30244C9.05505 8.44463 8.96025 8.62874 8.96025 8.85478C8.96025 9.22301 9.23734 9.48551 9.7915 9.64228L10.7103 9.93213C12.154 10.3478 12.8595 11.1243 12.8267 12.2618C12.823 12.5972 12.7537 12.9017 12.6188 13.1751C12.4876 13.4485 12.309 13.6764 12.0829 13.8587C11.8605 14.0373 11.6108 14.1813 11.3337 14.2907C11.0603 14.3965 10.7668 14.4657 10.4532 14.4985V15.7892H9.63291V14.4985C8.90739 14.4256 8.3277 14.1741 7.89385 13.7438C7.46364 13.31 7.24854 12.7741 7.24854 12.136Z",
  fill: "currentColor"
});

var SvgDollar = function SvgDollar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDollar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar.690dedeb.svg";
export { ForwardRef as ReactComponent };